import api from './api';
import { getCsrfToken } from '../utils/utils';

const AuthAPI = {
    login: async (locationId, ghlToken) => {
      try {
        const response = await api.post('/auth/login', {
          location_id: locationId, // Use 'location_id' as per the API
          ghl_auth_token: ghlToken, // Use 'ghl_auth_token' as per the API
        });
        return response.data; // Assuming the API returns the user data
      } catch (error) {
        // Handle error response from the API
        if (error.response) {
          throw new Error(error.response.data.error || 'Login failed');
        } else {
          throw new Error('Login failed. Please check your connection.');
        }
      }
    },
  
    verify: async () => {
      try {
        const response = await api.get('/auth/verify', {
          withCredentials: true, // Include cookies in the request
        });
        return response.data; // Assuming the API returns the user data and tokens
      } catch (error) {
        // Handle error response from the API
        if (error.response) {
          throw new Error(error.response.data.error || 'Verification failed');
        } else {
          throw new Error('Verification failed. Please check your connection.');
        }
      }
    },
  
    logout: async () => {
      try {
        const response = await api.post(
          '/auth/logout',
          {}, // empty body
          {
            headers: {
              'X-CSRF-TOKEN': getCsrfToken(), // Make sure header name matches backend expectation
            },
            withCredentials: true, // Important: ensures cookies are sent with request
          }
        );
        return response.data;
      } catch (error) {
        if (error.response) {
          throw new Error(error.response.data.error || 'Logout failed');
        } else {
          throw new Error('Logout failed. Please check your connection.');
        }
      }
    },

    registerClient: async (formData) => {
      try {
        const response = await api.post('/auth/register/client', {
          company_name: formData.company_name,
          email: formData.email,
          password: formData.password,
          vapi_token: formData.vapi_token
        });
        return response.data;
      } catch (error) {
        if (error.response) {
          throw new Error(error.response.data.message || 'Registration failed');
        } else {
          throw new Error('Registration failed. Please check your connection.');
        }
      }
    }
  };
  
  export default AuthAPI; // Export the AuthAPI module 